import React from 'react'
import styled from 'styled-components'
import { COLORS } from '../../constants'
import { InfoLabel } from '@fluentui/react-components'

const CheckboxContainer = styled.label`
  display: flex;
  align-items: center;
  cursor: pointer;
  position: relative;
  user-select: none;
`

const HiddenCheckbox = styled.input.attrs({ type: 'checkbox' })`
  display: none;
`

type CustomCheckboxProps = {
  color?: string
}

const CustomCheckbox = styled.span<CustomCheckboxProps>`
  position: relative;
  height: 20px;
  width: 20px;
  background-color: #fff;
  border: 2px solid #ccc;
  border-radius: 4px;
  transition:
    background-color 0.3s ease,
    border-color 0.3s ease;
  margin-right: 5px;

  ${HiddenCheckbox}:checked + & {
    background-color: ${(props) => props.color || '#4caf50'};
    border-color: ${(props) => props.color || '#4caf50'};
  }

  &:after {
    content: '';
    position: absolute;
    display: none;
  }

  ${HiddenCheckbox}:checked + &:after {
    display: block;
    left: 7px;
    top: 3px;
    width: 5px;
    height: 10px;
    border: solid white;
    border-width: 0 2px 2px 0;
    transform: rotate(45deg);
  }
`

const CheckboxLabel = styled.span`
  font-size: 1.1rem;
  margin-left: 5px;
`

type CheckboxProps = {
  label: string
  checked: boolean
  setChecked: (checked: boolean) => void
  info?: string
}

const Checkbox: React.FC<CheckboxProps> = ({
  label,
  checked,
  setChecked,
  info
}) => {
  const toggleCheckbox = () => setChecked(!checked)

  return (
    <CheckboxContainer>
      <HiddenCheckbox checked={checked} onChange={toggleCheckbox} />
      <CustomCheckbox color={COLORS.primary} />
      <CheckboxLabel>
        <InfoLabel info={info}>{label}</InfoLabel>
      </CheckboxLabel>
    </CheckboxContainer>
  )
}

export default Checkbox
